import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private translate: TranslateService, @Inject(DOCUMENT) private document: Document) {}

  // Définit la langue et la direction du texte (RTL/LTR)
  setLanguage(lang: string) {
    const supported = ['en', 'fr', 'es', 'ar'];
    this.translate.addLangs(supported);
    this.translate.setDefaultLang('en');
    this.translate.use(lang.match(/en|es|pt|de|ar|fr|/) ? lang : "en");

    const isRTL = ['ar', 'he', 'fa', 'ur'].includes(lang);
    this.document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    this.document.body.classList.toggle('rtl', isRTL);

  }

  // Retourne la langue courante ou une valeur par défaut
  getCurrentLang(): string {
    return this.translate.currentLang || this.translate.getDefaultLang() || 'en';
  }

  
}
